import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { parseParams } from "../../../helpers/clean-object";
import { CreateUserSiteInput } from "../../../__generated__/globalTypes";
import {
  CreateUserSiteMutation,
  CreateUserSiteMutationVariables,
} from "../../../__generated__/CreateUserSiteMutation";
import { CREATE_USER_SITE } from "../user-sites.queries";

interface IProps {
  defaultValues: {
    userId: number;
    siteId?: number;
  };
  onCompleted: () => any;
}

export const useCreateUserSite = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateUserSiteInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateUserSiteMutation,
    CreateUserSiteMutationVariables
  >(CREATE_USER_SITE);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createUserSite?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createUserSite?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
